import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class NoteService {
  constructor() {}

  ALL_NOTES = [
    'A',
    'A# / Bb',
    'B',
    'C',
    'C# / Db',
    'D',
    'D# / Eb',
    'E',
    'F',
    'F# / Gb',
    'G',
    'G# / Ab',
  ];

  getSequentialNotes(open: string, totalFrets: number) {
    let notes = [
      'A',
      'A# / Bb',
      'B',
      'C',
      'C# / Db',
      'D',
      'D# / Eb',
      'E',
      'F',
      'F# / Gb',
      'G',
      'G# / Ab',
    ];

    const allNotes = [];
    let cursor = notes.findIndex((n) => n === open) + 1;

    for (let i = 1; i <= totalFrets; i++) {
      if (!notes[cursor]) {
        cursor = 0;
      }

      allNotes.push(notes[cursor]);
      cursor++;
    }

    return allNotes;
  }
}
